import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private readonly STORAGE_KEY = 'sidebar_collapsed';

  // Desktop sidebar collapsed state (persisted in localStorage)
  isCollapsed = signal<boolean>(
    typeof localStorage !== 'undefined' && localStorage.getItem(this.STORAGE_KEY) === 'true'
  );

  // Mobile drawer state
  drawerOpen = signal<boolean>(false);

  /**
   * Toggle desktop sidebar collapsed / expanded state
   */
  toggleCollapse(): void {
    const next = !this.isCollapsed();
    this.isCollapsed.set(next);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(this.STORAGE_KEY, String(next));
    }
  }

  /**
   * Explicitly set desktop collapsed state
   */
  setCollapsed(collapsed: boolean): void {
    this.isCollapsed.set(collapsed);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(this.STORAGE_KEY, String(collapsed));
    }
  }

  /**
   * Toggle mobile drawer
   */
  toggleDrawer(): void {
    this.drawerOpen.update((open) => !open);
  }

  /**
   * Set mobile drawer visibility
   */
  setDrawerOpen(open: boolean): void {
    this.drawerOpen.set(open);
  }
}
